export default __webpack_public_path__ + "images/WS.c4d2faf.png";